var Keyboard = require('./keyboard.es6').default;
var urlUtil = require('./url.es6');

// jquery
// Fix browser support props
// http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
$.browser = {};

function testCSS (prop) {
    return prop in document.documentElement.style;
}

// Opera 8.0+
$.browser.opera = !!(window.opera && window.opera.version);
// FF 0.8+
$.browser.mozilla = testCSS('MozBoxSizing');
// At least Safari 3+: "[object HTMLElementConstructor]"
$.browser.safari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
// Chrome 1+
$.browser.chrome = !$.browser.safari && testCSS('WebkitTransform');
// At least IE6
$.browser.msie = false || testCSS('msTransform');

// jquery ui
var oldMouseStart = $.ui.sortable.prototype._mouseStart;
$.ui.sortable.prototype._mouseStart = function(event, overrideHandle, noActivation) {
    this._trigger("beforestart", event, this._uiHash());
    oldMouseStart.apply(this, [event, overrideHandle, noActivation]);
};

// jquery timeago
$.timeago.settings.autoDispose = true;
$.timeago.settings.allowFuture = true;

// Date
Date.prototype.formatTime = function () {
    var formatString = '';
    var seconds = '';
    if (window.getPref('time-seconds')) {
        seconds = ':ss';
    }
    if (window.getPref('time-24hr')) {
        formatString += 'HH:mm' + seconds;
    } else {
        formatString += 'h:mm' + seconds + ' tt';
    }
    return this.toString(formatString);
};
Date.prototype.formatFullDate = function () {
    var formatString = 'dddd, MMMM dd, yyyy ';
    if (window.getPref('time-24hr')) {
        formatString += 'HH:mm:ss';
    } else {
        formatString += 'h:mm:ss tt';
    }
    return this.toString(formatString);
};
Date.prototype.isSameDay = function (date) {
    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    return this.toString("yyyy-MM-dd") === date.toString("yyyy-MM-dd");
};

// Backbone
// Add an event bubbling method
Backbone.Model.prototype.bubble = function (event, parent, as) {
    this.bind(event, function () {
        var args = _.toArray(arguments);
        args.unshift(as || event);
        parent.trigger.apply(parent, args);
    }, this);
};
Backbone.Collection.prototype.bubble = Backbone.Model.prototype.bubble;
Backbone.View.prototype.bubble = Backbone.Model.prototype.bubble;
Backbone.View.prototype.cached = function (property, accessor, timeout) {
    timeout = timeout || 1000;
    if (!this[property]) {
        this[property] = accessor();
        setTimeout(_.bind(function () {
            this[property] = null;
        }, this), timeout);
    }
    return this[property];
};
Backbone.Collection.prototype.previous = function (model) {
    var index = this.indexOf(model);
    if (index > 0) {
        return this.at(index - 1);
    }
};
Backbone.Collection.prototype.next = function (model) {
    return this.at(this.indexOf(model) + 1);
};

Backbone.Router.prototype._extractParameters = function(route, fragment) {
    var params = route.exec(fragment).slice(1);
    return _.map(params, function(param, i) {
        // Don't decode any params.
        return param || null;
    });
};

// debug
window.irccloud_debug.head = function (count) {
    count = count || 100;
    var logger = debug.getLogger(true);
    debug.getLogs().slice(0, count).forEach(function (log) {
        logger.apply(window, log);
    });
};
window.irccloud_debug.tail = function (count) {
    count = count || 100;
    var logger = debug.getLogger(true);
    debug.getLogs().slice(-count).forEach(function (log) {
        logger.apply(window, log);
    });
};

var route_re = /^\/(irc([\/?#]|$)|[!?#]|$)/;
$(document).on('click', 'a[href]:not([target=_blank])', function(e) {
    if (window.SESSION) {
        var href = $(this).attr("href");
        var urlParts = urlUtil.urlParts(href);
        if (urlUtil.isCurrentUrl(urlParts)) {
            href = urlParts.pathname + urlParts.search + urlParts.hash;
        }
        if (route_re.test(href)) {
            e.preventDefault();
            window.SESSION.trigger('navigate', href.slice(1), {trigger: true});
            return false;
        }
    }
});

// button clicks
// Need to trigger button clicks separately due to browser bugs sometimes
// not triggering click when positioning button between mousedown and mouseup
// Capture button mouse presses (which = 1) means left click only (jQuery normalised)
var buttonPressed;
$(document).on('mousedown', 'button', function (e) {
    if (e.which == 1) {
        buttonPressed = $(e.target).closest('button:not([disabled])');
    }
});
// Clear button press on all mouseups
$(document).on('mouseup', function (e) {
    if (e.which == 1 && buttonPressed) {
        // Check target matches and trigger new event
        var target = $(e.target).closest('button');
        if (target.is(buttonPressed)) {
            var pos = buttonPressed.position();
            buttonPressed.trigger('buttonClick', {x: pos.left, y: pos.top});
        }
        buttonPressed = null;
    }
});
$(document).on('keypress', '[role~=tab]:not([disabled]), [role~=button]:not([disabled])', function (e) {
    if (e.key === 'Enter' || e.key == ' ') {
        var target = $(e.target);
        // Suppress space scroll down
        e.preventDefault();
        var pos = target.position();
        target.trigger('buttonClick', {x: pos.left, y: pos.top, keypress: true});
    }
});
// Fire custom buttonClick on return
$(document).on('click', 'button', function (e) {
    // Don't mess with button links
    if (!$(e.target).is('a')) {
        if (Keyboard.isClickEnter(e)) {
            // Pressing return will always have detail 0
            // And won't have the isPrimary flag on
            var button = $(e.target).closest('button:not([disabled])');
            var pos = button.position();
            button.trigger('buttonClick', {x: pos.left, y: pos.top, keypress: true});
            // Suppress bubble to avoid multiple submits
            return false;
        }  else {
            // Suppress bubble to avoid triggering clickoff dialog handler
            return false;
        }
    }
});
// If a buttonClick bubbles to the top, submit the nearest form because we're
// suppressing the click
$(document).on('buttonClick', 'button', function (e) {
    // Default type for <button> is submit. Use type="button" to avoid this
    if (e.target.type == 'submit') {
        $(e.target).closest('form').submit();
        return false;
    }
});



//////////////////
// WEBPACK FOOTER
// ./app/src/lib/patches.js
// module id = hF98
// module chunks = 1